import format from 'date-fns/format';
import differenceInDays from 'date-fns/difference_in_days';
import addMinutes from 'date-fns/add_minutes';
import addHours from 'date-fns/add_hours';
import addDays from 'date-fns/add_days';
import isValid from 'date-fns/is_valid';
import isWithinRange from 'date-fns/is_within_range';

import { GetSessions } from '../../../database/helpers';

// const DB_REFRESH = {
//   0: [0, 0, 15],
//   1: [0, 1, 0],
//   3: [0, 12, 0],
//   7: [1, 0, 0],
// };

const getRefresh = date => {
  const now = new Date();
  const dif = differenceInDays(now, date);

  if (dif === 0) return addMinutes(now, 15);
  if (dif > 0 && dif <= 3) return addHours(now, 1);
  if (dif > 3 && dif <= 7) return addHours(now, 6);

  return addDays(now, 1);
};

const getUpdated = async (db, key) => {
  try {
    const dateStr = await db.get('updated', key);
    const date = new Date(dateStr);
    if (isValid(date)) return date;
    return false;
  } catch (e) {
    return false;
  }
};

export const shouldUpdate = async (db, date, key) => {
  const refreshDate = getRefresh(date);
  const updated = await getUpdated(db, key);
  if (!updated) return true;
  return isWithinRange(updated, new Date(), refreshDate);
};

export default (db, currentStore) => {
  const getSessions = GetSessions(db, currentStore);
  return date => {
    const key = format(date, 'YYYY-MM-DD');
    // console.log();
    if (!shouldUpdate(db, date, `${key}-${currentStore}`)) return null;
    return getSessions(date);
  };
};
